import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col } from 'antd';
import ShopifyVariantsFilter from './components/ShopifyVariantsFilter';
import ShopifyVariantsList from './components/ShopifyVariantsList';
import { fetchShopifyVariants, applyFilters } from './actions';
import './ShopifyVariants.css';

const ShopifyVariants = () => {
    const dispatch = useDispatch();
    const [filterVisible, setFilterVisible] = useState(false);

    const {
        variants,
        isLoading,
        filters,
        pagination
    } = useSelector((state) => state.shopifyVariants);

    useEffect(() => {
        // Fetch variants on mount
        dispatch(fetchShopifyVariants(1, pagination.pageSize));
    }, [dispatch]);

    const handleApplyFilters = (filterValues) => {
        dispatch(applyFilters(filterValues));
        setFilterVisible(false);
    };

    const handleResetFilters = () => {
        const defaultFilters = {
            searchText: '',
            shopifyStoreId: 'all',
            shopifyProductId: 'all',
            hasSku: undefined,
            hasBusinessSku: undefined,
            inventoryStatus: 'all'
        };
        dispatch(applyFilters(defaultFilters));
        setFilterVisible(false);
    };

    return (
        <div className="shopify-variants-container">
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Card
                        title="Shopify Variants Management"
                        size="small"
                        className="shopify-variants-card"
                    >
                        <ShopifyVariantsFilter
                            visible={filterVisible}
                            setVisible={setFilterVisible}
                            onApply={handleApplyFilters}
                            onReset={handleResetFilters}
                            currentFilters={filters}
                        />
                        <ShopifyVariantsList
                            variants={variants}
                            isLoading={isLoading}
                            pagination={pagination}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ShopifyVariants;
